// extracted by mini-css-extract-plugin
export var pageContainer = "_f-1";
export var settingsContent = "_f-0";